import camelcase from 'camelcase-keys-deep';
import { createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { createResource } from '@gandi/resource/redux';
import { fetchPrices, selectPrices } from '../common';
export const priceMailboxesResource = createResource('Price mailboxes');
export const fetchMailboxesPrices = args => dispatch => dispatch(fetchPrices(priceMailboxesResource)(args));
const sortByMinDurationAccumulator = (acc, price) => {
  acc[price.minDuration] = price;
  return acc;
};
export const selectMailboxesPrices = createSelector((state, props) => selectPrices(state, {
  product: 'mailboxes',
  params: props
}), catalog => {
  const products = catalog?.products || [];
  return products.reduce((acc, product) => {
    const productPrices = product.prices.reduce(sortByMinDurationAccumulator, {});
    acc[product.name] = productPrices;
    return acc;
  }, {});
});
export const selectMailboxPrice = createSelector((state, props) => props.minDuration, (state, props) => props.mailboxType, (state, props) => selectPrices(state, {
  product: 'mailboxes',
  params: props
}), (minDuration, mailboxType, catalog) => {
  const products = catalog?.products || [];
  const mailbox = products.find(product => product.name === mailboxType);
  return mailbox?.prices.find(price => price.minDuration === minDuration);
});
const initialState = {};
const reducer = createReducer({
  [priceMailboxesResource.fetchOne.success.getType()]: (state, payload) => ({
    ...state,
    [payload.label]: camelcase(payload.response.data)
  })
}, initialState);
export default reducer;